export const WHY_ONEMIND_CONSTANTS = {
  title: "POC-as-a-Service by OneMind Cloud Services",
  desc: [
    {
      text: "At OneMind Cloud Services, we offer an industry-leading POC-as-a-Service (POCaaS) solution that helps businesses validate technologies before full-scale implementation. Our cloud-based POC environments provide a realistic and risk-free testing ground for evaluating new software, network configurations, and enterprise solutions.",
      highlight: [
        "OneMind Cloud Services",
        "POC-as-a-Service (POCaaS)",
        "cloud-based ",
        "POC environments",
        "realistic ",
        " risk-free testing",
      ],
    },
  ],
};
